import { useEffect } from "react";

export const useRefreshToken = () => {
  useEffect(() => {
    // Legacy no-op: session refresh is now centralized in Authenticated/sessionManager.
  }, []);
};